/* eslint-disable import/extensions */
import React from 'react';
import PopRefer from './PopRefer.js';
import Refer from './index.js';

class ReferWithUnit extends PopRefer {
	constructor(props) {
		super(props);
		this.state = {
			...this.state,
			unit: props.defaultUnitValue || {}
		};
	}

	renderPopoverHeaderExtend = () => {
		const { unitProps, isShowUnit, unitCondition, unitPropsExtend, onUnitChange } = this.props;
		let props = { ...unitProps };
		if (unitPropsExtend) {
			props = { ...unitProps, ...unitPropsExtend };
		}
		if (unitCondition) {
			props = { ...unitProps, queryCondition: unitCondition };
		}
		let hotKeyMap = this.getHotKeyMap();
		return (
			isShowUnit && (
				<div
					style={{ width: '200px', marginLeft: '20px' }}
					className='cancel-drag'
				>
					<Refer
						{...props}
						value={this.state.unit}
						onChange={(value, foolValue) => {
							// this.loadSelectedData();
							onUnitChange?.(value, foolValue);
							this.setState(
								{
									unit: value
								},
								() => {
									this.show(true);
								}
							);
						}}
						popWindowClassName="refer-unit-pop-window"
						container={this.props.container}
						baseTabIndex={this.getTabIndex(
							[
								...hotKeyMap.keys()
							][hotKeyMap.size - 1]
						)}
						tabIndex={this.getTabIndex(this.hotKeyElement.unit)}
						onFocus={() => {
							this.unitReferFocusFlag = true;
						}}
						onBlur={() => {
							this.unitReferFocusFlag = false;
						}}
					/>
				</div>
			)
		);
	};
}

export default ReferWithUnit;
